import Modules from 'application/modules'
import { Roles } from 'core/auth/constants'
import React, { useContext } from 'react'
import { ACLContext } from './Provider'


type ControlledComponentProps = {
  children: React.ReactNode
  module: Modules
  role: Roles
  applyHierarchy?: boolean
}

const hierarchyMap = {
  [Roles.OU]: [Roles.OU],
  [Roles.SU]: [Roles.OU, Roles.SU],
}

export default function AccessControlledComponent({ module, role, children, applyHierarchy = true }: ControlledComponentProps) {
  const { state } = useContext(ACLContext)

  const hasPermission = state.ACL.some(moduleGroup => {
    if (hierarchyMap[Roles.SU].includes(moduleGroup.role)) {
      const hasModulePermission = moduleGroup.moduleName === module
      const hasNecessaryRole = applyHierarchy ? hierarchyMap[moduleGroup.role].includes(role) : role === moduleGroup.role
      
      return hasModulePermission && hasNecessaryRole
    }

    return false
  })

  if (!hasPermission) return <></>

  return <>{children}</>
}
